export enum ViewName{
    VIEW_FOR_ORDER_INSPECTOR = "VIEW_FOR_ORDER_INSPECTOR",
    PAGE_PROPERTY_VIEW = "PAGE_PROPERTY_VIEW",
    DOCUMENT_ENTRY_VIEW = "DOCUMENT_ENTRY_VIEW",
    PROPERTY_VIEW_FOR_DOCUMENT_PAGE = "PROPERTY_VIEW_FOR_DOCUMENT_PAGE",
    PROPERTY_PLATFORM_VIEW = "PROPERTY_PLATFORM_VIEW",
    PLAIN_PROPERTY = "PLAIN_PROPERTY"
}
